<template>
  <div id="wrapper">
    <div class="logInBlock">
      <div class="logInBoard">
        <div class="logImg"> <img src="@/images/img_logIn.svg" alt=""></div>
        <div class="logInFormBox">
          <slot></slot>
        </div>
      </div>
    </div>
    <!-- footer-->
  </div>
</template>

<script setup>
import { ref, provide, inject, onMounted, reactive, watch, nextTick } from "vue";
import { useRouter } from 'vue-router';

const storer = inject('store');
const router = useRouter();

const isLogin = ref(false);

const logout = () => {
  localStorage.removeItem('LoginInfo');
  storer.value.model.loginInfo = null;
  router.push('/login')
}

const menuBtn = ref(null);

const model = reactive({});
onMounted(async () => {

})


</script>

<style scoped></style>
